import React, { Component } from "react";
import { currentLocals } from "../../languages/languages.js";

import Conversion from "../../containers/ConversionContainer.js";
import "../../styles/OnBoarding.css";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import { Tooltip, Box } from "@mui/material";
import { EmptyState } from "@lectra/mui-library";
/*import ConversionFinder from '../../containers/ConversionFinderContainer';*/

export default class ConversionList extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateStatus = this.handleUpdateStatus.bind(this);
    this.onChronoClick = this.onChronoClick.bind(this);
    this.onEraseListClick = this.onEraseListClick.bind(this);
    this.onRemoveJobsClick = this.onRemoveJobsClick.bind(this);
    this.handleDownLoadAllMDL = this.handleDownLoadAllMDL.bind(this);
  }
  handleUpdateStatus(event) {
    let element = event.target;

    let myConversions = this.state.conversions;
    for (let i in myConversions.Conversion) {
      let conversion = myConversions.Conversion[i];
      if (conversion.id === element.getAttribute("conversionid")) {
        myConversions.Conversion[i].status = element.getAttribute("value");
        break;
      }
    }
  }
  handleDownLoadAllMDL(event, dataout, datain, id) {
    const { downLoadMDL } = this.props;
    let txt = "DownLoad_";
    let length = txt.length;

    var x = document.getElementsByClassName("download");
    var i;
    for (i = 0; i < x.length; i++) {
      if (x[i].style.visibility === "visible") {
        let idDL = x[i].id;
        let id = idDL.substring(length);
        //alert(idDL);
        downLoadMDL({ id });
      }
    }
  }
  state = {
    viewchrono: false,
  };

  onChronoClick() {
    let chronoheader = document.getElementById("chronoheader");
    chronoheader.className =
      chronoheader.className === "header-item chrono hidechrono"
        ? "header-item chrono viewchrono"
        : "header-item chrono hidechrono";
    let view = chronoheader.className === "header-item chrono viewchrono" ? true : false;
    this.setState({ viewchrono: view });
  }

  onEraseListClick() {
    const { removeAllConversion } = this.props;
    removeAllConversion({});
  }
  onRemoveJobsClick() {}

  render() {
    const { conversions } = this.props;
    let resultsbody = window.document.getElementById("resultsbody");
    if (resultsbody != null) resultsbody.scrollTop = resultsbody.scrollHeight;

    let displayConversionsBodyEmpty;
    if (conversions.length > 0) displayConversionsBodyEmpty = "none";
    else displayConversionsBodyEmpty = "block";

    return (
      <div className="ConversionList conversion">
        <div className="table" id="resultsTable">
          <div>
            <img
              id="DownloadImg"
              className="tourDownloadConversionList tourDownloadConversionListHide"
              data-tut="reactour__conversionbardownloadimage"
            ></img>
            <img
              id="ViewPAConversion"
              className="tourViewPAConversionList tourViewPAConversionListHide"
              data-tut="reactour__whatisnewViewPaternAssistant"
            ></img>
            <img
              id="ViewPaternAssistant"
              className="whatisnewViewPaternAssistant whatisnewViewPaternAssistantHide"
              data-tut="reactour__whatisnewViewPaternAssistant"
            ></img>
          </div>
          <div className="results-header">
            {/*<div id="clearlist" className="header-item eraselist" onClick={this.onEraseListClick}>
              &nbsp;
    </div>*/}
            <Tooltip title={currentLocals(this.props.locale).conversion.EraseList}>
              <PlaylistRemoveIcon
                className="header-item eraselist"
                font-size="37px"
                style={{ color: "#0000008A" }}
                onClick={(event) => {
                  this.onEraseListClick(event);
                }}
              ></PlaylistRemoveIcon>
            </Tooltip>
            <div className="header-item date">{currentLocals(this.props.locale).conversion.DateTime}</div>
            <div className="header-item datain">{currentLocals(this.props.locale).conversion.DataIn}</div>
            <div className="header-item dataout" data-tut="reactour__conversionbardataout">
              {currentLocals(this.props.locale).conversion.DataOut}
            </div>
            <div className="header-item converter">{currentLocals(this.props.locale).conversion.Converter}</div>
            <div className="header-item conversion">{currentLocals(this.props.locale).conversion.Conversion}</div>
            <div className="header-item status">{currentLocals(this.props.locale).conversion.Status}</div>
            <div className="header-item viewpatternassistant">&nbsp;</div>
            <Tooltip title={currentLocals(this.props.locale).conversion.DownloadAll}>
              <CloudDownloadIcon
                className="header-item downloadall"
                font-size="17px"
                data-tut="reactour__downloadall"
                style={{ color: "#0000008A" }}
                onClick={(event) => {
                  this.handleDownLoadAllMDL(event);
                }}
              ></CloudDownloadIcon>
            </Tooltip>
          </div>
          {/*
          <div
            className="results-body ConversionsBodyEmpty"
            id="resultsbodyEmpty"
            style={{ display: displayConversionsBodyEmpty }}
          >
            <div className="ConversionsBodyEmpty Title">
              {currentLocals(this.props.locale).conversion.ConversionListEmpty}
            </div>
            <div className="ConversionsBodyEmpty Description">
              {currentLocals(this.props.locale).conversion.ChooseATile}
            </div>
          </div>
              */}
          <div style={{ display: displayConversionsBodyEmpty }}>
            <Box sx={{ backgroundColor: "white" }}>
              <EmptyState
                title={currentLocals(this.props.locale).conversion.ConversionListEmpty}
                text={currentLocals(this.props.locale).conversion.ChooseATile}
              ></EmptyState>
            </Box>
          </div>

          <div className="results-body ConversionsBody" id="resultsbody">
            {conversions.map((conversion) => (
              <Conversion
                key={conversion.id}
                viewchrono={this.state.viewchrono}
                user={conversion.user}
                datain={conversion.datain}
                dataout={conversion.dataout}
                id={conversion.id}
                date={conversion.date}
                converter={conversion.converter}
                type={conversion.type}
                status={conversion.status}
                description={conversion.description}
              ></Conversion>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
